<template>
  <div class="container mescroll-touch">
    <!-- <img src="../../assets/images/acmedtopback.png" class="img" /> -->
    <!-- <img src="../../assets/images/guanggaotop.png" class="guanggaoimg" /> -->
    <!-- <el-carousel :interval="5000" arrow="always" class="elbanner">
      <el-carousel-item v-for="item in bannerlist" :key="item.Id">
        <img :src="item.ImgUrl" class="bannerimg" @click="jumpimgurl(item.LinkUrl, item.Id, item.Description)" />
      </el-carousel-item>
    </el-carousel> -->

    <van-swipe ref="banner" class="elbanner" autoplay="5000" indicator-active-color="#FFFFFF">
      <van-swipe-item v-for="item in bannerlist" :key="item.Id">
        <img :src="item.ImgUrl" class="bannerimg" @click="jumpimgurl(item.LinkUrl, item.Id, item.Description)" />
      </van-swipe-item>
    </van-swipe>

    <div class="btnlist">
      <div class="btnrow">
        <div class="btnsimple">
          <div class="btnincolnew">
            <div class="btnsmall1">
              <div class="btnsmall2 btnheng">
                <!-- <img src="../../assets/images/xximg.png" class="btnmimg3" /> -->
                <div class="timem" v-if="isopen == 0">距大会开幕式还有</div>
                <div class="timem" v-if="isopen == 0">
                  <span class="timel">{{ day }}</span>天
                </div>
                <div class="timem" v-if="isopen == 1">
                  <span class="timel">大会已结束</span>
                </div>
                <div class="times" v-if="isopen == 0">
                  {{ hh }}时 {{ mm }}分 {{ ss }}秒
                </div>
                <!-- <div class="btntext2">基本<br />信息</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btnrow">
        <div class="btnmiddle" @click="gowelcome()">
          <img src="../../assets/images/hyimg.png" class="btnmimg" />
          <div class="btntext">欢迎辞</div>
        </div>
        <div class="btnlarge" @click="goregmeeting()">
          <img src="../../assets/images/zcimg.png" class="btnmimg1" />
          <div class="btntext1">注册<br />及缴费</div>
        </div>
      </div>

      <div class="btnrow">
        <div class="btnlarge" @click="gotimeline()">
          <img src="../../assets/images/huiimg.png" class="btnmimg2" />
          <div class="btntext1">会议<br />日程</div>
        </div>
        <div class="btnmiddleleft" @click="gojoinme()">
          <img src="../../assets/images/canhuilogo.png" class="btnmimg" style="width: 46%" />
          <div class="btntext">参会指南</div>
        </div>
      </div>

      <div class="btnrow">
        <div class="btnmiddle3" @click="gozuzhi()">
          <img src="../../assets/images/jiagounew.png" class="btnmimg" />
          <div class="btntext8">组织架构</div>
        </div>
        <div class="btnmiddle" @click="goToExternalLink()">
          <img src="../../assets/images/xximg.png" class="btnmimg" />
          <div class="btntext">征文投稿</div>
        </div>
        <div class="btnmiddle4" @click="gozb()">
          <img src="../../assets/images/zhiboimg.png" class="btnmimg" />
          <div class="btntext10">会议直播</div>
          <div class="btntext11">（图&视频）</div>
        </div>
      </div>

      <div class="btnrow">
        <div class="btnmiddle" @click="gojiaotong()">
          <img src="../../assets/images/jtimg.png" class="btnmimg11" />
          <div class="btntext">交通住宿信息</div>
        </div>
        <div class="btnmiddle3" @click="gocontact()">
          <img src="../../assets/images/lianxiimg.png" class="btnmimg" />
          <div class="btntext8">联系方式</div>
        </div>
        <div class="btnmiddle5" @click="godownfile()">
          <img src="../../assets/images/downloadimg.png" class="btnmimg" />
          <div class="btntext">下载专区</div>
        </div>
      </div>

      <!--<div class="btnrow">
        <div class="btnlong" @click="gozn()">
          <img src="../../assets/images/kefuimg.png" class="btnmimg21" />
          <div class="btntext81">智能客服</div>
        </div>
      </div>-->
    </div>
    <div class="tcout" v-if="showtc == 1">
      <div class="tcimg">
        <div class="jumptc" @click="gotcurl(list.LinkUrl, list.Id, list.Description)">
          <img :src="list.ImgUrl" class="tcimgin" />
        </div>
        <div class="close" @click="closebtn()">
          <img src="../../assets/images/tcclose.png" class="tcimgin" />
        </div>
      </div>

      <div class="back"></div>
    </div>
  </div>
</template>

<script>
import mixin from "../../common/mixin/mixins";
export default {
  name: "ACMED",
  data() {
    return {
      day: 0,
      hh: 0,
      mm: 0,
      ss: 0,
      list: {},
      showtc: 0,
      bannerlist: [],
      isopen: 0,
    };
  },
  mixins: [mixin],
  components: {},
  watch: {
    bannerlist(newVal) {
      if (newVal.length > 0) {
        this.$nextTick(() => {
          const indicators = this.$refs.banner.$el.querySelectorAll('.van-swipe__indicator')
          indicators.forEach((dot, index) => {
            dot.addEventListener('click', () => {
              this.$refs.banner.swipeTo(index);
            })
          })
        })
      }
    }
  },
  created() {
    this.getimg();
    this.getlunbo();
    this.count();
    this.initacmedShare();
    document.title = "ACMED第一届学术年会";
  },
  methods: {
    gotcurl(u, id, d) {
      if (u) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: d,
            TCode: 'activity_link',
            Rid: id,
          },)
          .then((res) => {
            window.location.href = u;
          });
      }

    },
    getimg() {
      let that = this;
      let isClose = sessionStorage.getItem("acmedLinkClose");
      if (!isClose) {
        this.$axios
          .post("/api/api/web/activity/GetActivityLink", {
            Code: "ACMEDIndex",
          })
          .then((res) => {
            // console.log(res.data.Data)
            if (res.Data.length > 0) {
              that.showtc = 1;
              that.list = res.Data[0];
            } else {
              that.showtc = 0;
            }
            // console.log(this.list)
          });
      }
    },
    getlunbo() {
      let that = this;
      this.$axios
        .post("/api/api/web/activity/GetActivityBanner", {
          Code: "ACMEDIndex",
        })
        .then((res) => {
          // console.log(res.data.Data)
          if (res.Data) {
            that.bannerlist = res.Data;
          }
          // console.log(this.list)
        });
    },
    gowelcome() {
      this.$router.push({ name: "welcome" });
    },
    goregmeeting() {
      this.$router.push({ name: "regmeeting" });
    },
    gobaseinfo() {
      this.$router.push({ name: "baseinfo" });
    },
    gozuzhi() {
      this.$router.push({ name: "zuzhi" });
    },
    gocontact() {
      this.$router.push({ name: "contact" });
    },
    gotimeline() {
      this.$router.push({ name: "timeline" });
    },
    gojoinme() {
      this.$router.push({ name: "joinmeeting" });
    },
    gozn() {
      this.$router.push({ name: "zhineng" });
    },
    gozb() {
      // this.$router.push({ name: "acmedzhibo" });
      this.$router.push({
        path: 'liveList',
        query: {
          code: "zbzt_zbhj",
          Tcode: "zbzt|zbzt_zbhj|"
        }
      });
    },
    gojiaotong() {
      this.$router.push({ name: "jiaotong" });
    },
    godownfile() {
      this.$router.push({ name: "downfile" });
    },
    goToExternalLink() {
      window.location.href =
        "https://mp.weixin.qq.com/s/RHB8GQKTO26LIph6Z5sZDQ";
    },
    closebtn() {
      this.showtc = 0;
      sessionStorage.setItem("acmedLinkClose", "1");
    },
    count() {
      // 设置倒计时的结束时间为未来某个时间
      var endTime = new Date("2025/8/23 08:00:00");
      let that = this;
      // 每秒执行一次
      setInterval(function () {
        // 获取当前时间和结束时间的时间差
        var nowTime = new Date();
        var timeDiff = endTime.getTime() - nowTime.getTime();
        // console.log(timeDiff)
        // 计算剩余时间
        var days = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
        var hours = Math.floor((timeDiff / 1000 / 60 / 60) % 24);
        var minutes = Math.floor((timeDiff / 1000 / 60) % 60);
        var seconds = Math.floor((timeDiff / 1000) % 60);
        that.ss = seconds;
        that.hh = hours;
        that.day = days;
        that.mm = minutes;
        // 将剩余时间显示在页面上
        if (timeDiff <= 0) {
          that.isopen = 1;
        }
        // var countdownDiv = document.getElementById("countdown");
        // countdownDiv.innerHTML = "距离2024年元旦还有：" + days + "天" + hours + "小时" + minutes + "分" + seconds + "秒";
        // console.log("距离还有：" + this.day + "天" + hours + "小时" + minutes + "分" + this.ss + "秒")
      }, 1000);
    },
    jumpimgurl(url, id, d) {
      if (url) {
        this.$axios
          .post("/api/api/web/BuriedPoint/AddBP", {
            BPType: 2,
            Name: d,
            TCode: 'activity_banner',
            Rid: id,
            UpId: '1'
          })
          .then((res) => {
            window.location.href = url;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  width: 100%;
  background: rgb(228, 236, 255);
  position: relative;
}

.img {
  display: block;
  width: 100%;
  margin-bottom: 0.2rem;
}

.guanggaoimg {
  display: block;
  width: 92%;
  margin: auto;
  margin-bottom: 0.2rem;
  padding-top: 0.3rem;
}

.btnlist {
  display: flex;
  flex-direction: column;
  width: 92%;
  margin: auto;
}

.btnrow {
  display: flex;
  flex-direction: row;
  margin-bottom: 0.2rem;
}

.btnmiddle {
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  width: 33%;
  border-radius: 5px;
  padding: 0.3rem 0;
  box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  margin-right: 0.2rem;
}

.btnmiddleleft {
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  width: 33%;
  border-radius: 5px;
  padding: 0.3rem 0;
  box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  margin-left: 0.2rem;
}

.btnmiddle5 {
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  width: 33%;
  border-radius: 5px;
  padding: 0.3rem 0;
  box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  // margin-right: .2rem;
}

.btnmiddle1 {
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  width: 33%;
  border-radius: 5px;
  padding: 0.3rem 0;
  box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  // margin-right: .2rem;
}

.btnmiddle3 {
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  width: 33%;
  border-radius: 5px;
  padding: 0.3rem 0;
  box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  margin-right: 0.2rem;
}

.btnmiddle4 {
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  width: 33%;
  border-radius: 5px;
  padding: 0.3rem 0;
  box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  // margin-right: .2rem;
}

.btnmiddletw {
  // background-image: linear-gradient(to right, rgb(154, 144, 255), rgb(183, 179, 255));
  width: 33%;
  border-radius: 5px;
  padding: 0.3rem 0;
  // box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  // margin-right: .2rem;
  position: relative;
}

.btnmiddletw1 {
  // background-image: linear-gradient(to right, rgb(154, 144, 255), rgb(183, 179, 255));
  width: 33%;
  border-radius: 5px;
  padding: 0.3rem 0;
  // box-shadow: -1px 1px 1px 1px rgba(0, 0, 0, 0.1);
  margin-right: 0.2rem;
  position: relative;
}

.btnmimg {
  display: block;
  width: 50%;
  margin: auto;
}

.btnmimg11 {
  display: block;
  width: 30%;
  margin: auto;
}

.btnmimg21 {
  display: block;
  width: 10%;
  margin: auto 0;
}

.btntext {
  display: block;
  text-align: center;
  width: 100%;
  margin-top: 0.3rem;
  font-size: 16px;
  color: rgb(248, 248, 221);
  font-weight: bold;
}

.btntext10 {
  display: block;
  text-align: center;
  width: 100%;
  // margin-top: 0.3rem;
  font-size: 16px;
  color: rgb(248, 248, 221);
  font-weight: bold;
}

.btntext8 {
  display: block;
  text-align: center;
  width: 100%;
  margin-top: 0.4rem;
  font-size: 16px;
  color: rgb(248, 248, 221);
  font-weight: bold;
}

.btntext81 {
  display: block;
  text-align: center;
  width: 30%;
  font-size: 16px;
  color: rgb(248, 248, 221);
  font-weight: bold;
}

.btntext11 {
  display: block;
  text-align: center;
  width: 100%;
  font-size: 12px;
  color: rgb(248, 248, 221);
  font-weight: bold;
}

.btnlarge1 {
  display: flex;
  flex-direction: row;
  width: 66%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  margin-right: 0.2rem;
}

.btnlarge {
  display: flex;
  flex-direction: row;
  width: 66%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
}

.btnlong {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
}

.btnmimg1 {
  display: inline-block;
  width: 30%;
  margin: auto;
  margin-right: 0.3rem;
  margin-left: 0;
}

.btnmimg2 {
  display: inline-block;
  width: 30%;
  margin: auto;
  margin-right: 0.6rem;
  margin-left: 0;
}

.btnmimg3 {
  display: inline-block;
  width: 30%;
  margin: auto;
  margin-right: 0.2rem;
  margin-left: 0;
}

.btntext1 {
  display: block;
  text-align: center;
  font-size: 26px;
  color: rgb(248, 248, 221);
  font-weight: bold;
}

.btntext2 {
  display: block;
  text-align: center;
  font-size: 15px;
  color: #fff;
  font-weight: bold;
}

.btnincol {
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  top: 0;
  justify-content: space-between;
  height: 100%;
}

.btnsmall {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.11rem 0;
  position: relative;
  margin-top: 0.1rem;
}

.btnsmall4 {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.18rem 0;
  position: relative;
}

.btnsmall1 {
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  // padding: 0.18rem 0;
}

.btnsmall2 {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.05rem 0;
  // position: absolute;
  // left: 0;
  // top: 0;
  color: rgb(248, 248, 221);
  font-weight: bold;
}

.timem {
  font-size: 0.4rem;
}

.times {
  font-size: 0.4rem;
}

.timel {
  font-size: 0.6rem;
}

.btnsmall5 {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-image: linear-gradient(to right, rgb(0, 53, 131), rgb(0, 59, 185));
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 0.18rem 0;
  position: relative;
  margin-top: 0.1rem;
}

.btntext3 {
  display: block;
  text-align: center;
  font-size: 15px;
  color: rgb(248, 248, 221);
  font-weight: bold;
}

.btnsimple {
  position: relative;
  width: 100%;
}

.btnincolnew {
  position: unset;
}

.btnheng {
  flex-direction: row;
}

.tcout {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 20;

  .tcimg {
    display: block;
    width: 80%;
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    z-index: 30;

    .close {
      width: 1rem;
      height: 1rem;
      display: block;
      margin: auto;
      margin-top: 0.2rem;
    }

    img {
      display: block;
      width: 100%;
    }
  }

  .back {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 25;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
  }
}

// .jumptc {}
.bannerimg {
  width: 100%;
  display: block;
}

.elbanner {
  position: relative;
  height: 4.15rem;
  width: 93%;
  margin: auto;
  overflow: hidden;
  padding-top: 0.3rem;
}

::v-deep .el-carousel__container {
  height: 100%;
}

::v-deep .el-carousel__indicators--horizontal {
  bottom: 5%;
}
</style>